import { Users, Handshake, Sprout } from "lucide-react";

const BrandPhilosophy = () => {
  const philosophies = [
    {
      icon: <Users className="w-8 h-8 text-[#F39800]" />,
      title: "여행자를 위한 진심",
      description: "저렴하면서도 가성비 높은 숙소 정보를 제공합니다. 샤워실, 세탁기, 신발건조기 등 트레커에게 꼭 필요한 편의시설 정보를 투명하게 안내합니다.",
      highlight: "여행자 중심 서비스"
    },
    {
      icon: <Handshake className="w-8 h-8 text-[#F39800]" />,
      title: "함께 성장하는 생태계",
      description: "숙박업주에게는 새로운 수익성 모델을 제공하고, 지역 경제 활성화에 기여합니다. 트레커와 지역사회가 함께 win-win 할 수 있는 구조를 만들어갑니다.",
      highlight: "공생 모델"
    },
    {
      icon: <Sprout className="w-8 h-8 text-[#F39800]" />,
      title: "문화를 만드는 여행",
      description: "걷기 여행문화를 확산시키는 씨앗이 되겠습니다. 양질의 콘텐츠와 활발한 커뮤니티를 통해 한국의 도보 여행 문화를 활성화합니다.",
      highlight: "문화 활성화"
    }
  ];

  return (
    <section id="brand-philosophy" className="py-20 bg-gradient-to-br from-white via-orange-50 to-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#F39800]/10 text-[#F39800] px-4 py-2 rounded-full text-sm font-medium mb-6">
            <span>🌱</span>
            <span>홀씨의 철학</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-6">
            홀씨가 만들어가는
            <span className="block text-[#F39800] mt-2">새로운 여행문화</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            한국의 걷기 여행문화 활성화의 씨앗이 되겠습니다. <br />
            여행자, 지역사회, 그리고 문화가 함께 성장하는 생태계를 만듭니다.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {philosophies.map((philosophy, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105 border border-gray-100"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="p-3 bg-[#F39800]/10 rounded-xl">
                  {philosophy.icon}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-gray-800 leading-tight">
                    {philosophy.title}
                  </h3>
                </div>
              </div>

              <p className="text-gray-600 leading-relaxed mb-4">
                {philosophy.description}
              </p>

              <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#F39800]/20 to-[#F39800]/10 text-[#F39800] px-3 py-1 rounded-full text-sm font-medium">
                <span className="w-2 h-2 bg-[#F39800] rounded-full"></span>
                <span>{philosophy.highlight}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <div className="bg-white/80 backdrop-blur-sm rounded-3xl p-8 shadow-lg border border-white/50 max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800 mb-4">
              홀씨와 함께 새로운 여행을 시작하세요
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              단순한 여행이 아닌, 문화를 만들어가는 특별한 경험을 제공합니다.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <div className="flex items-center gap-2 text-[#F39800] font-medium">
                <Users className="w-5 h-5" />
                <span>여행자 중심</span>
              </div>

              <span className="hidden sm:block text-gray-400">•</span>
              <div className="flex items-center gap-2 text-[#F39800] font-medium">
                <Handshake className="w-5 h-5" />
                <span>공생 생태계</span>
              </div>

              <span className="hidden sm:block text-gray-400">•</span>
              <div className="flex items-center gap-2 text-[#F39800] font-medium">
                <Sprout className="w-5 h-5" />
                <span>문화 활성화</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandPhilosophy;
